import { connect } from "react-redux";
import PaymentCounteragentToCounterScreen from "./PaymentCounteragentToCounterScreen";
import { paymentCounteragentToCounter } from "src/counters/redux/actions";

export default connect(
  (state) => {
    return {
      profile: state.auth.profile,
      counteragents: state.counteragents.counteragents,
      counters: state.counters.counters,
    };
  },
  { paymentCounteragentToCounter }
)(PaymentCounteragentToCounterScreen);
